import { defineAction } from '~/prix'
import geoReverseGeocodingAction from './geoReverseGeocoding.action.json' with { type: 'json' }
import { z } from 'zod'
import { latitude, longitude } from '~/prix/types/presets/geo'

const geoReverseGeocodingDefinition = defineAction({
  ...geoReverseGeocodingAction,

  input: z.object({
    latitude: latitude(),
    longitude: longitude(),
    include: z
      .array(z.string())
      .describe('Campos adicionais a serem incluídos na resposta.')
      .optional(),
    limit: z
      .number()
      .min(1)
      .max(15)
      .describe('Número máximo de resultados a serem retornados.')
      .optional(),
  }),
  output: z.object({
    results: z.array(z.any()).describe('Resultados da geocodificação reversa.').nullish(),
    items: z.array(z.any()).describe('Resultados da geocodificação reversa.').nullish(),
  }),
})

export default geoReverseGeocodingDefinition
